import { Component, ElementRef, EventEmitter, HostListener, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild } from '@angular/core';

let compteur = 0;

/**
 * Feuille basse sur mobile, panneau latéral sur ordinateur.
 * Dialogue accessible : role="dialog", focus déplacé à l'ouverture et rendu à la fermeture, Échap, clic hors panneau.
 */
@Component({
  selector: 'bay-bottom-sheet',
  template: `
    <ng-container *ngIf="open">
      <div class="bay-sheet-backdrop" (click)="fermer()"></div>
      <section #panel class="bay-sheet" [class.bay-sheet-large]="large" role="dialog" aria-modal="true"
        [attr.aria-labelledby]="titreId" tabindex="-1">
        <header class="bay-sheet-head">
          <div class="bay-sheet-grip d-md-none" aria-hidden="true"></div>
          <div class="min-w-0">
            <h2 class="bay-sheet-title" [id]="titreId">{{ titre }}</h2>
            <p *ngIf="sousTitre" class="bay-sheet-sub">{{ sousTitre }}</p>
          </div>
          <button type="button" class="bay-icon-btn" (click)="fermer()" aria-label="Fermer">
            <span class="material-symbols-outlined" aria-hidden="true">close</span>
          </button>
        </header>
        <div class="bay-sheet-body"><ng-content></ng-content></div>
        <footer class="bay-sheet-foot"><ng-content select="[sheet-actions]"></ng-content></footer>
      </section>
    </ng-container>
  `
})
export class BottomSheetComponent implements OnChanges, OnDestroy {
  @Input() open = false;
  @Input() titre = '';
  @Input() sousTitre = '';
  @Input() large = false;
  @Output() closed = new EventEmitter<void>();
  @ViewChild('panel') panel?: ElementRef<HTMLElement>;

  readonly titreId = `bay-sheet-titre-${++compteur}`;
  private focusAvant: HTMLElement | null = null;

  ngOnChanges(c: SimpleChanges): void {
    if (c.open) {
      if (this.open) {
        this.focusAvant = document.activeElement as HTMLElement;
        document.body.classList.add('bay-sheet-ouverte');
        setTimeout(() => {
          const p = this.panel?.nativeElement;
          const cible = p?.querySelector<HTMLElement>('[autofocus], input:not([type=hidden]):not([disabled]), select, textarea') || p;
          cible?.focus();
        });
      } else {
        this.restaurer();
      }
    }
  }

  @HostListener('document:keydown.escape')
  onEscape(): void { if (this.open) this.fermer(); }

  fermer(): void {
    this.closed.emit();
  }

  private restaurer(): void {
    document.body.classList.remove('bay-sheet-ouverte');
    this.focusAvant?.focus?.();
    this.focusAvant = null;
  }

  ngOnDestroy(): void { if (this.open) this.restaurer(); }
}
